// extracted by mini-css-extract-plugin
module.exports = {"footer-wrapper":"Footer_footer-wrapper__2Il7j","footer-copyright":"Footer_footer-copyright__34rhq","footer-nav":"Footer_footer-nav__1DP_I","links":"Footer_links__y-LA_"};